import { useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { mdiChevronDown } from "@mdi/js";
import Icon from "@mdi/react";
import { motion } from "framer-motion";


export default function LandingFAQ(){

	const [perguntas, setPerguntas] = useState([
		{pergunta: "Como funciona o método de cobrança da Tribo Barber?", resposta: "A Tribo Barber é a única plataforma no Brasil que não cobra mensalidade. Utilizamos um método de cobrança inovador, baseado em um percentual sobre cada venda que você realiza. Acreditamos no sucesso mútuo, e nossa parceria é construída com base nos resultados que alcançamos juntos. Quando você ganha, nós também ganhamos.", aberto: false},
		{pergunta: "Qual é a vantagem de ter um aplicativo web exclusivo para minha barbearia com a Tribo Barber?", resposta: "Com a Tribo Barber, você recebe um aplicativo web exclusivo para seus clientes, personalizado com o logotipo e o nome da sua barbearia. Isso é fornecido sem custo adicional, eliminando a necessidade de investir em desenvolvimento de aplicativos. Dessa forma, você fortalece sua marca e oferece uma experiência única aos seus clientes.", aberto: false},
		{pergunta: "Como a Tribo Barber me ajuda a aumentar meu faturamento?", resposta: "A Tribo Barber não se limita ao gerenciamento; nossa metodologia única e inovadora vai além, revelando os segredos das maiores barbearias do mundo. Com acesso a aulas gratuitas sobre gestão eficiente, técnicas de vendas, e muito mais, você terá as ferramentas necessárias para duplicar ou triplicar seu faturamento em poucos meses.", aberto: false},
		{pergunta: "Como funciona a comunidade exclusiva?", resposta: "Ao se tornar parceiro da Tribo Barber, você ganha acesso a uma comunidade exclusiva. Neste ambiente, interaja com os melhores barbeiros do Brasil, tire dúvidas, faça networking e receba conteúdo atualizado sobre produtos e eventos. Além disso, tenha acesso a empresas parceiras da plataforma, como contabilidade, marketing e produtos.", aberto: false},
		{pergunta: "Qual é a garantia oferecida pela Tribo Barber?", resposta: "Acreditamos no poder transformador da nossa plataforma e oferecemos uma garantia exclusiva. No seu primeiro mês de uso, não cobramos a nossa taxa de serviço. Explore todas as funcionalidades da plataforma sem a necessidade de investir dinheiro. Para nós, conquistar sua confiança é prioridade.", aberto: false},
	]);

	const animations = {
		show: {
			opacity: 1,
			y: 0,
			transition: {
				when: "beforeChildren",
				staggerChildren: 0.1,
				duration: 0,
			}
		},
		hidden: {
			opacity: 0,
			y: 0,
			transition: {
				when: "afterChildren",
				staggerChildren: 0.1,
				duration: 0,
			}
		}
	}
	
	const animationsChildren = {
		show: {
			opacity: 1,
			scale: 1,
			y: 0,
			transition: {
				duration: 0.5,
			}
		},
		hidden: {
			opacity: 0,
			scale: 0.5,
			y: 50,
			transition: {
				duration: 0.5,
			}
		}
	}

	return (
		<Container fluid id="contato" className="py-5 position-relative" >
			<Container>
				<Row>
					<Col className="d-flex flex-column justify-content-center align-items-center mb-4 fs-1 text-white fw-bold">
						Perguntas frequentes
					</Col>
				</Row>
				<motion.div variants={animations} initial={"hidden"} whileInView={"show"} viewport={{margin: "-100px"}}>
					{perguntas.map((pergunta, key)=>{
						return (
							<motion.div variants={animationsChildren} key={key}>
								<Row>
									<Col lg={{span: 10, offset: 1}} className={`border-top border-dark ${perguntas.length-1===key && "border-bottom"}`}>
										<Row className="p-3 align-items-center cursor-pointer" onClick={()=>{ setPerguntas(p=> p.map((item, index)=>{ return index===key ? {...item, aberto: !pergunta.aberto} : item })) }}>
											<Col className="d-flex align-items-center fs-5">
												{pergunta.pergunta}
											</Col>
											<Col xs="auto">
												<motion.div initial={{rotate: 0}} animate={{rotate: pergunta.aberto ? 180 : 0}} transition={{type: "tween"}}>
													<Icon path={mdiChevronDown} size={2}/>
												</motion.div>
											</Col>
										</Row>
										
										<motion.div initial={{height: 0}} animate={{height: pergunta.aberto ? "auto" : 0}} transition={{type: "tween"}} className="overflow-hidden">
											<Row className="p-3 bg-dark">
												<Col className="d-flex align-items-center fs-5 fw-light">
													{pergunta.resposta}
												</Col>
											</Row>
										</motion.div>
										
									</Col>
								</Row>
							</motion.div>
						)
					})}
				</motion.div>
			</Container>
		</Container>
	)
}